/// <amd-module name="TFS/Views/PieChart/PieChart" />

import * as React from "react";
import * as d3 from "d3";
import { getId } from "VSS/Core/Util/Object";
import { css } from "VSSUI/Util";

export interface PieChartProps {
    data: number[];
    graphHeight: number;
    graphWidth: number;
    outerRadius: number;
    colors: string[];
    innerRadius?: number;
    pieChartText?: string;
    pieChartClass?: string;
    textClass?: string;
}

export class PieChart extends React.Component<PieChartProps, {}> {
    private _graphContainerId: string;
    private _svgId: string;

    constructor(props: PieChartProps) {
        super(props);

        this._graphContainerId = getId("graph-container");
        this._svgId = getId("svg-id");
    }

    public render(): JSX.Element {
        return (
            <div className={css(this.props.pieChartClass, "relative")} id={this._graphContainerId}>
                {this.props.pieChartText && <div className={css(this.props.textClass, "absolute-fill")}>{this.props.pieChartText}</div>}
            </div>
        );
    }

    public componentDidMount(): void {
        this._drawPieChart();
    }

    public componentDidUpdate(): void {
        this._drawPieChart();
    }

    private _drawPieChart(): void {
        const color = d3.scaleOrdinal(this.props.colors);

        // remove existing node before rendering new node
        d3.select("#" + this._svgId).remove();

        const svg = d3
            .select("#" + this._graphContainerId)
            .append("svg")
            .attr("id", this._svgId)
            .attr("width", this.props.graphWidth)
            .attr("height", this.props.graphHeight);

        // Generate the pie without changing the order of data
        const pie = d3.pie().sort(null);

        // Generate the arcs
        const arc = d3
            .arc<d3.PieArcDatum<number>>()
            .innerRadius(this.props.innerRadius ? this.props.innerRadius : 0)
            .outerRadius(this.props.outerRadius);

        const g = svg.append("g").attr("transform", "translate(" + this.props.outerRadius + "," + this.props.outerRadius + ")");

        const arcs = g
            .selectAll(".arc")
            .data(pie(this.props.data))
            .enter()
            .append("g")
            .attr("class", "arc");

        arcs.append("path")
            .attr("fill", (d, i) => {
                return color(i.toString());
            })
            .attr("d", arc);
    }
}
